<template>
  <div class="relative inline-block text-left">
    <div class="flex items-center">
      <Globe class="w-4 h-4 text-slate-400 mr-2 hidden sm:block" />
      
      <select
        v-model="currentLang"
        @change="onChange"
        class="appearance-none bg-white border border-slate-200 text-slate-700 text-sm font-bold rounded-xl pl-3 pr-8 py-1.5 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 cursor-pointer transition-all shadow-sm hover:bg-slate-50"
      >
        <option value="en">English</option>
        <option value="zh">中文</option>
      </select>
      
      <ChevronDown class="w-4 h-4 text-slate-400 absolute right-2 top-1/2 -translate-y-1/2 pointer-events-none" />
    </div>
  </div>
</template>

<script setup>
import { ref, watch, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
import { Globe, ChevronDown } from 'lucide-vue-next'

const { locale, setLocale } = useI18n()

// 🌟 1. 使用本地 ref 绑定 select，避开 SSR 直接绑定 locale 造成的 DOM 渲染不同步
const currentLang = ref(locale.value)

// 🌟 2. 监听 i18n 全局语言的变化，保持双向同步
watch(locale, (newVal) => {
  currentLang.value = newVal
})

// 🌟 3. 页面在浏览器挂载完成后，强制读取 localStorage 对齐 UI 显示
onMounted(() => {
  if (process.client) {
    const savedLocale = localStorage.getItem('app_locale')
    if (savedLocale && savedLocale !== currentLang.value) {
      currentLang.value = savedLocale // 更新下拉框显示
      setLocale(savedLocale)          // 更新全局语言
    }
  }
})

// 🌟 4. 用户手动选择语言时的处理
const onChange = async () => {
  await setLocale(currentLang.value)
  if (process.client) {
    localStorage.setItem('app_locale', currentLang.value) // 记住语言设置
  }
}
</script>
